import { SSMClient, GetParameterCommand, PutParameterCommand, DeleteParameterCommand } from '@aws-sdk/client-ssm';
import { CodeCommitClient, GetFileCommand, ListFileCommitHistoryCommand } from '@aws-sdk/client-codecommit';
import { CognitoIdentityClient } from '@aws-sdk/client-cognito-identity';
import { fromCognitoIdentityPool } from '@aws-sdk/credential-provider-cognito-identity';
import cognitoAuthConfig from '../../config';

const config = user => ({
    region: cognitoAuthConfig.region,
    credentials: fromCognitoIdentityPool({
        client: new CognitoIdentityClient({ region: cognitoAuthConfig.region }),
        identityPoolId: cognitoAuthConfig.identityPoolId,
        logins: {
            [`cognito-idp.${cognitoAuthConfig.region}.amazonaws.com/${cognitoAuthConfig.userPoolId}`]: user.id_token
        },
    })
})

const ssm = (user) => {
    return new SSMClient(config(user))
};
const codecommit = (user) => {
    return new CodeCommitClient(config(user))
};

const GetCommitHistory = async (user, value, callbacks) => {
    const command = new ListFileCommitHistoryCommand({
        repositoryName: "integrations-dynamodb", // required
        filePath: value, // required
        nextToken: null
    })
    // const response = await codecommit(user).send(command)
    let result = []
    while (command.input.nextToken !== undefined) {
        let response = await codecommit(user).send(command)
        if (response.$metadata.httpStatusCode === 200) {
            result = [...result, ...response.revisionDag];
            command.input.nextToken = response.nextToken;
        } else {
            callbacks.forEach(fn => fn([]));
            return { severity: "error", message: response }
        }
    }
    for await (const fn of callbacks) {
        await fn(result)
    }
}

const GetFile = async (user, value, commitId) => {
    const command = new GetFileCommand({
        repositoryName: "integrations-dynamodb",
        filePath: value,
        commitSpecifier: commitId
    })
    let result = await codecommit(user).send(command).then(
        (data) => {
            const content = JSON.parse(new TextDecoder().decode(data.fileContent)).query.S
            return content
        },
        (error) => {
            console.log(value, 'error', error)
            return ""
        }
    )
    return result
}

const GetSecureValue = async (user, value) => {
    let command = new GetParameterCommand({
        Name: value,
        WithDecryption: true
    });
    let result = await ssm(user).send(command).then(
        (data) => {
            return data.Parameter.Value
        },
        (error) => {
            console.log(value, 'error', error)
            return ""
        }
    )
    return result
}
const PutSecureValue = async (user, key, value) => {
    let command = new PutParameterCommand({
        Name: key,
        Value: value,
        Type: 'SecureString',
        Overwrite: true
    });
    let result = await ssm(user).send(command).then(
        (data) => {
            console.log('success', data)
            return
        },
        (error) => {
            console.log('error', error)
        }
    )
    return result
}

const DeleteSecureValue = async (user, key) => {
    let command = new DeleteParameterCommand({
        Name: key,
    });
    let result = await ssm(user).send(command).then(
        (data) => {
            return data
        },
        (error) => {
            console.log(error)
        }
    )
    return result
}

export { GetSecureValue, PutSecureValue, DeleteSecureValue, GetCommitHistory, GetFile }